<template>
	<div class="box">
		<div class="charts-header">
			<div>
				<span>选择数据</span>
				<div class="dxchack" v-show="xzBool">
					 <el-checkbox-group v-model="checkList">
					    <el-checkbox v-for="item in options1" :label="item.name" :key="item.id"></el-checkbox>
					  </el-checkbox-group>
				</div>
			</div>
			<div>{{name}}</div>
			<div class="fr" @click="exportExcel">导出数据</div>
		</div>
		<div>
			<div ref="echarts" class="echart">
  			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default{
		props: ['options1','name','zsoption','dates'],
		data(){
			return{
				xzBool:false,
				checkList:[],
				value:1,
				chart: null,
		        option: this.zsoption,
		        dates:this.dates
			}
		},
		 mounted() {
	      this.getPage()
	    },
	     watch:{
	    	zsoption:{
	    		handler(val,oldVal){
	    			this.getPage();
	    		},
	    		deep: true 
	    	},
	    },
		methods: {
			gshFn(str){
				var a=str[0].split('-');
				var b=str[1].split('-');
				console.log(a)
				return a[0]+a[1]+a[2]+'-'+b[0]+b[1]+b[2];
			},
		    getPage() {
		    	this.chart=null;
		        // 使用刚指定的配置项和数据显示图表。
	      		this.$nextTick(()=>{
		    		this.chart = echarts.init(this.$refs.echarts);
		        	this.chart.setOption(this.zsoption);
	        	})
		    },
		    exportExcel() {
				
				if(this.option.xAxis.data.length==0){
					this.$message({
						message: '暂无数据导出',
						type: 'error',
						duration: 1000,
						onClose: () => {
						}
					})
				}else{
					if(this.option.series[1]!=undefined){
						var arr=[]
						for(var i=0;i<this.option.xAxis.data.length;i++){
							var json={
								index:i,
								date:this.option.xAxis.data[i],
								num:this.option.series[0].data[i],
								nums:this.option.series[1].data[i],
							}
							arr.push(json)
						}
						
						arr.push(json)
						 require.ensure([], () => {
						    const { export_json_to_excel } = require('../Excel/Export2Excel');//注意这个Export2Excel路径
						    const tHeader = [ this.name,this.option.series[0].name,this.option.series[1].name];   // 上面设置Excel的表格第一行的标题
						    const filterVal = ['date', 'num','nums']; // 上面的index、nickName、name是tableData里对象的属性key值
						    const list = arr;  //把要导出的数据tableData存到list
						    const data = this.formatJson(filterVal, list);
						    export_json_to_excel(tHeader, data, this.name+'_'+this.gshFn(this.dates));//最后一个是表名字
						  })
						 this.$message({
							message: '已导出',
							type: 'success',
							duration: 1000,
							onClose: () => {
							}
						})
					}else{
						var arr=[]
						for(var i=0;i<this.option.xAxis.data.length;i++){
							var json={
								index:i,
								date:this.option.xAxis.data[i],
								num:this.option.series[0].data[i],
							
							}
							arr.push(json)
						}
						
						arr.push(json)
						 require.ensure([], () => {
						    const { export_json_to_excel } = require('../Excel/Export2Excel');//注意这个Export2Excel路径
						    const tHeader = [ this.name,this.option.series[0].name];   // 上面设置Excel的表格第一行的标题
						    const filterVal = ['date', 'num']; // 上面的index、nickName、name是tableData里对象的属性key值
						    const list = arr;  //把要导出的数据tableData存到list
						    const data = this.formatJson(filterVal, list);
						    export_json_to_excel(tHeader, data, this.name+'_'+this.gshFn(this.dates));//最后一个是表名字
						  })
						 this.$message({
							message: '已导出',
							type: 'success',
							duration: 1000,
							onClose: () => {
							}
						})
					}
					
					
				}
			},
			formatJson(filterVal, jsonData) {
			  return jsonData.map(v => filterVal.map(j => v[j]))
			},
		   },
		   
	}
</script>

<style scoped>
	.charts-header{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.charts-header>div:nth-child(1){
		border-bottom: 1px solid rgba(74,74,74,1);
		margin-left: 20px;
		/*cursor: pointer;*/
		opacity: 0;
	}
	.charts-header>div{
		margin: 0 auto;
		text-align: center;
		font-size:15px;
		font-family:PingFangSC-Semibold,PingFang SC;
		font-weight:600;
		color:rgba(74,74,74,1);
		line-height:21px;
		position: relative;
	}
	.dxchack{
		/*width: 100px;*/
		padding: 10px;
		z-index: 999;
		background: #FFFFFF;
		/*height: 100px;*/
		position: absolute;
		left: -10px;
		border:1px solid #CCCCCC;
	}
	.charts-header>div.fr{
		font-size:15px;
		font-family:PingFangSC-Semibold,PingFang SC;
		font-weight:600;
		color:rgba(74,74,74,1);
		line-height:21px;
		border-bottom: 1px solid rgba(74,74,74,1);
		height: 20px;
		cursor: pointer;
		margin-right: 60px;
	}
	.echart{
		width: 490px;
		height: 280px;
	}
	.charts-header>div.fr{
		height:30px;
		width:70px;
		background:rgba(29,181,255,1);
		border-radius: 4px;
		font-size:15px;
		font-family:PingFangSC-Semibold,PingFang SC;
		font-weight:600;
		color:#FFFFff;
		margin-right: 60px;
		border: 1px solid transparent;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}
	.charts-header>div.fr:hover{
		border: 1px solid yellow;
	}
</style>


// WEBPACK FOOTER //
// src/component/zxxyEchart.vue